export const messages = {
    ERROR: 'Something went wrong.',
    INTERNAL_SERVER_ERROR: 'The connection to the server failed. Please try again.'
};